import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../withRouter';
import actions from '../../../actions';
import {
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardTitle,
  CImage,
} from '@coreui/react';
import Button from '../../Common/HtmlTags/Button';
import Switch from '../../store/Switch';
import { resolvePartnerLogo } from '../../store/ResolveImage';
import { useNavigate, Link } from 'react-router-dom';
import ManagerPagination from '../Pagination';
import LoadingIndicator from '../../store/LoadingIndicator';

const ManagerPartnerLogosHelper = (props) => {
  const {
    isLightMode,
    partnerLogosList = [],
    isLoading,
    togglePartnerLogo,
  } = props;
  const navigate = useNavigate();
  const logosPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(partnerLogosList.length / logosPerPage);
  const startIndex = (currentPage - 1) * logosPerPage;
  const endIndex = startIndex + logosPerPage;
  const currentLogos = partnerLogosList.slice(startIndex, endIndex);

  return (
    <div data-aos='fade-up' className='container-lg px-4 d-flex flex-column mb-custom-5em partner-logos-manager'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div className='team-members-header d-flex justify-content-between align-items-center'>
        <h2 style={{ margin: 0 }} className={`${isLightMode ? 'p-black' : 'p-white'}`}>
          Partner Logos
        </h2>
        <Button
          onClick={() => navigate('/dashboard/partner-logos/add')}
          type='third-btn'
          text='Add Partner Logo +'
        />
      </div>
      <hr className={`${isLightMode ? 'p-black' : 'p-white'}`} />

      {!isLoading && currentLogos.length === 0 && (
        <p className={`${isLightMode ? 'p-black' : 'p-white'}`}>No partner logos yet. Add the first one.</p>
      )}

      <CRow className='gy-4'>
        {currentLogos.map((logo) => (
          <CCol xs={12} md={6} key={logo._id}>
            <CCard
              className={`${isLightMode ? 'bg-white p-black' : 'bg-black p-white border'} team-member-card flex-row overflow-hidden`}
            >
              <Link to={`/dashboard/partner-logos/edit/${logo._id}`} style={{ textDecoration: 'none', display: 'flex', flex: 1, overflow: 'hidden' }}>
                <CImage
                  src={resolvePartnerLogo(logo.imageUrl)}
                  alt={logo.name}
                  className='team-member-card-image partner-logo-card-image'
                />
                <CCardBody className='team-member-card-body'>
                  <CCardTitle className='mb-1'>{logo.name}</CCardTitle>
                  <p className='team-member-role mb-2'>
                    {logo.isEnabled ? 'Visible on site' : 'Hidden'}
                    {logo.isDefault ? ' · Default' : ''}
                  </p>
                </CCardBody>
              </Link>
              <div
                className='partner-logo-toggle'
                onClick={(event) => event.stopPropagation()}
              >
                <Switch
                  id={`partner-logo-toggle-${logo._id}`}
                  checked={logo.isEnabled !== false}
                  toggleCheckboxChange={(value) => togglePartnerLogo(logo._id, value)}
                />
              </div>
            </CCard>
          </CCol>
        ))}
      </CRow>

      <ManagerPagination
        isLightMode={isLightMode}
        data={partnerLogosList}
        totalPages={totalPages}
        startIndex={startIndex}
        endIndex={endIndex}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

class ManagerPartnerLogos extends React.PureComponent {
  componentDidMount() {
    this.props.fetchPartnerLogos();
  }

  render() {
    return <ManagerPartnerLogosHelper {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  partnerLogosList: state.partnerLogos.partnerLogosList,
  isLoading: state.partnerLogos.isLoading,
  isLightMode: state.dashboard.isLightMode,
});

export default connect(mapStateToProps, actions)(withRouter(ManagerPartnerLogos));
